module.exports = __webpack_public_path__ + "static/img/4_1.b8a06414.jpg";